__webpack_require__.p = "https://order-history.qa.tbconline.app/static/";